import * as React from 'react';
import * as styles from './styles.css';

import { UIText2 } from '@cian/ui-kit';

export const MoreDetailed: React.FC = () => {
  return (
    <div data-testid="MoreDetailed" className={styles['sc_info']}>
      <UIText2>
        <a href="https://support.cian.ru/ru/knowledge_base/art/181/cat/30/" target="_blank" rel="noreferrer">
          Подробнее о истории объявлений
        </a>
      </UIText2>
    </div>
  );
};

MoreDetailed.displayName = 'MoreDetailed';
